"use client";

import { useContentfulInspectorMode } from "@contentful/live-preview/react";
import React from "react";
import { CustomCSSProperties, TileProps } from "./Tile.types";
import { Default } from "./variations/Default";
import { Divider } from "./variations/Divider";
export const Tile: React.FC<Omit<TileProps, "inspector">> = ({ style: styleProp, content, ...rest }) => {
  const inspector = useContentfulInspectorMode();
  const style: CustomCSSProperties = { ...styleProp };

  if (content?.fields?.eyebrow_color) style["--tile-eyebrow-color"] = `var(${content.fields.eyebrow_color})`;
  if (content?.fields?.heading_color) style["--tile-heading-color"] = `var(${content.fields.heading_color})`;
  if (content?.fields?.subhead_color) style["--tile-subhead-color"] = `var(${content.fields.subhead_color})`;
  if (content?.fields?.body_color) style["--tile-body-color"] = `var(${content.fields.body_color})`;
  if (content?.fields?.icon_color) style["--tile-icon-color"] = `var(${content.fields.icon_color})`;

  if (content?.fields?.variation === "divider") {
    return <Divider {...rest} style={style} content={content} inspector={inspector} />;
  }

  return <Default {...rest} style={style} content={content} inspector={inspector} />;
};
